import React from "react";
import {
  useSearchParams,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import Deposit from "../components/Deposit";

const DepositsPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { walletBalances, fetchBalance } = useOutletContext();

  // Get preselected wallet from URL params
  const preSelectedWallet = searchParams.get("wallet");

  const handleBack = () => {
    navigate("/dashboard");
    // Refresh balance when returning from deposit
    fetchBalance();
  };

  return (
    <Deposit
      preSelectedWallet={preSelectedWallet}
      onBack={handleBack}
      walletBalances={walletBalances}
    />
  );
};

export default DepositsPage;
